import styled from "styled-components";

export const ContentContainer = styled.div`
  flex: 1;
  width: 100%;
  display: flex;
  padding-inline: 16px;
`;

export const PaginationWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 1.6rem;
`;

export const Content = styled.div`
  display: flex;
  flex: 1;
  gap: 8px;
  @media (max-width: 768px) {
    gap: 4px;
  }
`;

export const Column = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
  @media (max-width: 768px) {
    gap: 4px;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  flex: 1;
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 60px 20px;
  text-align: center;
  flex: 1;

  h3 {
    font-size: 24px;
    margin-bottom: 12px;
    font-family: Figtree;
  }

  p {
    font-size: 16px;
    line-height: 1.5;
    max-width: 400px;
    font-family: Figtree;
    opacity: 0.6;
    margin-bottom: 24px;
  }
`;

export const PlayboxBanner = styled.a`
  display: flex;
  width: 100%;
  max-width: 467px;
  padding: 0 12px 0 0;
  align-self: center;
  align-items: center;
  flex-direction: row;
  gap: 12px;
  border-radius: 8px;
  border: 2px solid #2d78ff;
  background: radial-gradient(50% 50% at 50% 50%, #214587 0%, #052752 100%);
  margin: 0 16px;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    transform: scale(1.01);
  }
`;

export const PlayboxBannerImageWrapper = styled.div`
  position: relative;
  width: 50px;
  height: 68px;
  flex-shrink: 0;
`;

export const PlayboxBannerImage = styled.img`
  width: 50px;
  height: 68px;
  border-radius: 6px;
  object-fit: cover;
`;

export const PlayboxBannerImageSmall = styled.img`
  position: absolute;
  top: 4px;
  left: 4px;
  width: 8px;
  height: 12px;
  transform: rotate(-0.815deg);
  border-radius: 2px;
  object-fit: cover;
`;

export const PlayboxBannerContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  min-width: 0;
`;

export const PlayboxBannerTitle = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: -0.24px;
`;

export const PlayboxBannerText = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: -0.21px;
  opacity: ${(p) => (p.$underline ? 1 : 0.7)};
  text-decoration: ${(p) => (p.$underline ? "underline" : "none")};
`;

export const PlayboxBannerChevron = styled.svg`
  flex-shrink: 0;
`;

export const Button = styled.button`
  display: flex;
  width: ${(props) => (props.$width ? "100%" : "180px")};
  height: 40px;
  padding: 12px 44px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 100px;
  background: #fff;
  border: none;
  outline: none;

  color: #081120;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;
  cursor: pointer;

  &:hover {
    transform: scale(1.05);
  }

  &:active {
    transform: scale(0.95);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;
